import 'css-chunksrc/client/common/preview/docxRenderer/styles.scss';export default {
  "renderer": "_renderer_1cd7d_1",
  "content": "_content_1cd7d_9"
};